// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.orange-gradient-button {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-family: inherit;
  font-weight: 500;
  font-size: 14px;
  padding: 0.7em 1.4em;
  letter-spacing: 0.05em;
  color: white;
  border: none;
  border-radius: 8px;

  /* گرادینت نارنجی-طلایی */
  background: #f97316; /* fallback */
  background: linear-gradient(
    0deg,
    rgba(234, 108, 34, 1) 0%,
    rgb(254, 147, 86) 100%
  );

  box-shadow: 0 0.1em 1.5em -0.5em #EA6C22;
  transition: box-shadow 0.2s ease;
}

.orange-gradient-button svg {
  margin-right: 4px; /* کمی فاصله استاندارد بین آیکون و متن */
}

.orange-gradient-button:hover {
  box-shadow: 0 0.5em 1.5em -0.5em #EA6C22;
}

.orange-gradient-button:active {
  box-shadow: 0 0.3em 1em -0.5em #EA6C22;
}

/* رسپانسیو موبایل */
@media (max-width: 820px) {
  .orange-gradient-button {
    padding: 0.6em 1em; /* پدینگ استاندارد */
    font-size: 13px; /* اندازه فونت استاندارد موبایل */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Button/OrangeGradientButton.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;;EAElB,yBAAyB;EACzB,mBAAmB,EAAE,aAAa;EAClC;;;;GAIC;;EAED,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,iBAAiB,EAAE,wCAAwC;AAC7D;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;AACxC;;AAEA,oBAAoB;AACpB;EACE;IACE,kBAAkB,EAAE,oBAAoB;IACxC,eAAe,EAAE,iCAAiC;EACpD;AACF","sourcesContent":[".orange-gradient-button {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  font-family: inherit;\n  font-weight: 500;\n  font-size: 14px;\n  padding: 0.7em 1.4em;\n  letter-spacing: 0.05em;\n  color: white;\n  border: none;\n  border-radius: 8px;\n\n  /* گرادینت نارنجی-طلایی */\n  background: #f97316; /* fallback */\n  background: linear-gradient(\n    0deg,\n    rgba(234, 108, 34, 1) 0%,\n    rgb(254, 147, 86) 100%\n  );\n\n  box-shadow: 0 0.1em 1.5em -0.5em #EA6C22;\n  transition: box-shadow 0.2s ease;\n}\n\n.orange-gradient-button svg {\n  margin-right: 4px; /* کمی فاصله استاندارد بین آیکون و متن */\n}\n\n.orange-gradient-button:hover {\n  box-shadow: 0 0.5em 1.5em -0.5em #EA6C22;\n}\n\n.orange-gradient-button:active {\n  box-shadow: 0 0.3em 1em -0.5em #EA6C22;\n}\n\n/* رسپانسیو موبایل */\n@media (max-width: 820px) {\n  .orange-gradient-button {\n    padding: 0.6em 1em; /* پدینگ استاندارد */\n    font-size: 13px; /* اندازه فونت استاندارد موبایل */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
